import { logWrapper } from '../utils';

function notificationToggleDirectiveFactory(runtimeConstant) {
  // eslint-disable-next-line no-unused-vars
  function link(scope, element, attrs) {
    const trigger = jQuery(element);
    const triggerNotif = trigger.data('trigger');
    const chatNotElem = '#chatNotification';
    const notifTrigger = '#notification-trigger';

    trigger.on('click', function (e) {
      e.preventDefault();
      jQuery(triggerNotif).toggleClass('toggled');
      trigger.toggleClass('open');

      if (triggerNotif === chatNotElem) {
        if (!jQuery('#sidebar').hasClass('toggled')) {
          jQuery('#header').toggleClass('sidebar-toggled');
        } else {
          jQuery('#sidebar').removeClass('toggled');
        }
      }

      if (jQuery('#header').hasClass('sidebar-toggled')) {
        jQuery(document).on('click.notification', function (e) {
          if (
            jQuery(e.target).closest(chatNotElem).length === 0 &&
            jQuery(e.target).closest(notifTrigger).length === 0
          ) {
            setTimeout(() => {
              jQuery(chatNotElem).removeClass('toggled');
              jQuery('#header').removeClass('sidebar-toggled');
              jQuery(notifTrigger).removeClass('open');
            });
            jQuery(document).off('click.notification');
          }
        });
      }
    });
  }

  function run() {
    try {
      return {
        restrict: 'A',
        link,
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const notificationToggleDirective = ['runtimeConstant', notificationToggleDirectiveFactory];
